import createIcon from '../../createIcon';

/**
 * @component @name Upload
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAyMC41SDE5VjE4LjVINVYyMC41Wk01IDEwLjVIOVYxNi41SDE1VjEwLjVIMTlMMTIgMy41TDUgMTAuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Upload = createIcon('Upload', [
  ['path', { d: 'M5 20.5H19V18.5H5V20.5ZM5 10.5H9V16.5H15V10.5H19L12 3.5L5 10.5Z', key: 'br284u' }],
]);

export default Upload;
